/**
 * TanStack Query hook for loading a single KYC form by ID via tRPC.
 * Transforms snake_case response to KYCFormData for form compatibility.
 */

import { useQuery } from "@tanstack/react-query";
import { transformDBKYBToKYCFormData } from "../services/data/api/kycProvider";
import { trpc } from "../trpc";
import type { KYCFormData } from "../types";

export function useKYBForm(formId: string | undefined, enabled: boolean) {
	const utils = trpc.useUtils();

	return useQuery({
		queryKey: ["kyb", formId],
		queryFn: async (): Promise<KYCFormData | null> => {
			if (!formId) return null;
			try {
				const form = await utils.kyb.getById.fetch({ id: formId });
				return transformDBKYBToKYCFormData(form);
			} catch {
				return null;
			}
		},
		enabled: enabled && !!formId && formId !== "new",
		staleTime: 60_000,
	});
}
